import * as React from 'react';
import { Circle } from '@chakra-ui/react';
import { getStickinessScoreColor } from './../../../utils';
import './Dot.scss';
type DotProps = {
  score: number;
};
function Dot(props: DotProps) {
  return (
    <Circle
      bg={getStickinessScoreColor(props.score)}
      className="dot"
      size="15px"
    />
  );
}
export default Dot;
